import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article';
}
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as];
  if (reduceMotion) {
    const Tag = as;
    return <Tag className={className} data-id="element-413" data-mp="2jr84r54imrxq">{children}</Tag>;
  }
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-414" data-mp="2jsszovuqscw4">
      {children}
    </MotionTag>;
}